import Link from 'next/link'
import { ReactNode } from 'react'
import { useDashboardWorkspaceContext } from '~/app/(dashboard)/dashboardContext'
import { isWorkspaceMemberViewer } from '~/app/(dashboard)/workspace/_utils'
import { cn } from '~/utils/cn'
import { useTranslation } from '~/i18n/useTranslation'
// import { FrigadeChecklist } from '@frigade/react'

// type DashboardChecklistProps = {
//   children?: ReactNode
// }

// export const DashboardChecklist = ({
//   children,
// }: DashboardChecklistProps) => {
//   return (
//     <FrigadeChecklist
//       type="inline"
//       flowId="flow_Ddbs6JznQ6QmOdFA"
//       checklistStyle="carousel"
//       appearance={{
//         styleOverrides: {
//           carouselCardImage: {
//             aspectRatio: '16/9',
//             height: 'auto',
//             borderRadius: 0,
//             width: '100%',
//             objectFit: 'cover',
//             borderBottom: '1px solid #e5e7eb'
//           },
//           carouselCard: {
//             padding: 0,
//             overflow: 'hidden',
//             borderRadius: '24px',
//             border: '1px solid #e5e7eb'
//           },
//           carouselCardTitle: {
//             padding: '0 1rem',
//           },
//           carouselCardSubtitle: {
//             padding: '0 1rem 1rem'
//           },
//           carouselContainer: {
//             background: 'none',
//             boxShadow: 'none',
//             padding: 0,
//           },
//           carouselSubtitle: { display: 'none' },
//           carouselCompletedPill: {
//             display: 'none',
//           },
//         },
//       }}
//     />
//   )
// }

function DashboardChecklistItem({
  title,
  src,
  alt,
  href,
  cta,
  external = true,
  disabled = false,
}) {
  return (
    <div className="border rounded-2xl max-w-[458px]">
      <img src={src} alt={alt} className="max-h-[220px]" />
      <div className="px-4 pb-6 pt-2 border-t">
        <h3 className="font-semibold text-lg text-gray-700 select-none mb-4">
          {title}
        </h3>
        <Link
          className={cn(
            'bg-blue-600 text-white font-medium px-4 py-2 rounded-lg',
            { 'cursor-not-allowed': disabled }
          )}
          href={disabled ? '#' : href}
          target={external ? '_blank' : '_self'}
          onClick={(e) => {
            if (disabled) {
              e.preventDefault()
            }
          }}
        >
          {cta}
        </Link>
      </div>
    </div>
  )
}

export function DashboardChecklist() {
  const { member } = useDashboardWorkspaceContext()
  const { t } = useTranslation()
  return (
    <div className="relative flex justify-between gap-4">
      <DashboardChecklistItem
        alt="Video preview"
        cta={t('dashboard.watchWalkthrough')}
        src="/img/checklist/onboard-1.png"
        title={t('dashboard.watchVideo')}
        href={'https://www.taloflow.ai/walkthrough-video'}
      />
      <DashboardChecklistItem
        external={false}
        alt="screen preview"
        href={'/evaluations/new'}
        cta={t('dashboard.createEvaluation')}
        src="/img/checklist/onboard-2.png"
        title={t('dashboard.createFirstEval')}
        disabled={isWorkspaceMemberViewer(member)}
      />
      <DashboardChecklistItem
        alt="screen preview"
        cta={t('dashboard.scheduleCall')}
        src="/img/checklist/onboard-3.png"
        href={'https://calendly.com/taloflow/expert'}
        title={t('dashboard.bookExpert')}
      />
    </div>
  )
}
